<template>
  <ancestryline-modal title="protocol.tab-checklist.send-process"  id="protocol-send-process-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-text v-model="form.trackingCode" label="protocol.tab-checklist.tracking-code" :error="validation.trackingCode"/>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('protocol.tab-checklist.send-process')" @click="sendProcess" class="p-ml-2"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import ValidationUtils from "@/utils/ValidationUtils";
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalSendProcess",

  data(){
    return {
      validation: {
        trackingCode: false,
      },
      form: {}
    }
  },

  methods:{
    close(){
      DialogService.closeModal();
    },
    sendProcess(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      if(!this.validation.erros){
        DialogService.closeModal(this.form.trackingCode);
      }
    }
  }
}
</script>